// Russian copy. Keys mirror sr.js; Russian uses the same three plural forms as Serbian.
const ru = {
  common: {
    skip: "Перейти к содержанию",
    call: "Позвонить",
    callNow: "Позвонить сейчас",
    callShort: "Позвонить",
    sendInquiry: "Отправить запрос",
    sendInquiryShort: "Запрос",
    allUnits: "Все квартиры",
    seeUnits: "Смотреть квартиры",
    seeFreeUnits: "Свободные квартиры",
    loading: "Загрузка…",
    priceOnRequest: "По запросу",
    openMaps: "Открыть в Google Картах",
    notRequired: "необязательно",
    close: "Закрыть",
    home: "Главная",
    backHome: "На главную",
    company: "Tehnočin DOO Invest",
    city: "Беочин",
  },
  nav: {
    offer: "Дома",
    units: "Квартиры",
    process: "Как мы строим",
    about: "О нас",
    location: "Расположение",
    faq: "Вопросы",
    contact: "Контакты",
    main: "Основная навигация",
    mobile: "Мобильная навигация",
    footer: "Ссылки в подвале",
    open: "Открыть меню",
    close: "Закрыть меню",
    logoHome: "Tehnočin DOO, главная",
  },
  lang: {
    label: "Язык",
    switchTo: "Открыть сайт на языке: {name}",
  },
  home: {
    hero: {
      eyebrow: "Новостройка · Беочин, Сербия",
      title: "Новые квартиры на площади Беочинский трг",
      lead: "Ламела A и Ламела B находятся в центре Беочина, рядом с Нови-Садом. Это жилые дома с коммерческими помещениями. Мы семейная компания, которая их строит, и квартиру вы покупаете напрямую у нас.",
      art: "Пиксельная анимация: дом растёт этаж за этажом рядом с краном",
    },
    facts: {
      label: "Коротко о проекте",
      offer: "Квартиры",
      offerValue: { one: "{count} квартира в 2 домах", few: "{count} квартиры в 2 домах", many: "{count} квартир в 2 домах" },
      offerFallback: "2 дома",
      free: "Свободно",
      price: "Цена",
      priceFrom: "от {price}",
      address: "Адрес",
      addressValue: "Beočinski trg 2 и 4",
    },
    stats: {
      eyebrow: "Наш опыт",
      title: "Что мы построили",
      items: [
        { value: "90+", label: "построенных квартир" },
        { value: "4 000+", label: "квадратных метров" },
        { value: "30+", label: "довольных покупателей" },
        { value: "2", label: "жилых дома с коммерцией" },
      ],
    },
    projects: {
      eyebrow: "Дома",
      title: "Выберите дом",
      lead: "Посмотрите свободные квартиры в обоих домах на площади Беочинский трг и выберите подходящую планировку.",
    },
    featured: {
      eyebrow: "Свободные квартиры",
      title: "Квартиры из нашего каталога",
    },
    process: {
      eyebrow: "Как мы строим",
      title: "От проекта до передачи квартиры",
      lead: "Наша команда ведёт стройку от фундамента до передачи ключей. У нас можно узнать, какие работы идут сейчас и на каком этапе строительство.",
      steps: [
        { title: "Проект и планировки", text: "До начала стройки готовим план каждой квартиры. Продумываем удобную планировку и светлые комнаты." },
        { title: "Строительство", text: "Наша команда и проверенные мастера строят по современным стандартам." },
        { title: "Контроль на стройке", text: "Мы сами ведём стройку и следим за сроками и качеством работ. Вы общаетесь с нами напрямую, без субподрядчиков." },
        { title: "Передача ключей", text: "В договоре чётко указываем цену и условия передачи квартиры." },
      ],
    },
    about: {
      eyebrow: "О нас",
      title: "Семейная строительная компания из Беочина",
      lead: "Мы семейная строительная компания Tehnočin из Беочина. Мы строим своей командой и с мастерами, которых знаем. С каждым покупателем чётко согласуем условия покупки.",
      photoAlt: "Рабочие Tehnočin DOO со спины перед строящимся зданием",
      values: [
        { title: "Десятилетия опыта", text: "Мы десятки лет работаем в строительстве. Знаем, как построить качественную квартиру, которая прослужит долго." },
        { title: "Семейная компания", text: "Мы на связи с покупателем от первого звонка и просмотра до передачи ключей." },
        { title: "Напрямую от застройщика", text: "Планировки, цены и условия покупки вы получаете напрямую от нас, без посредников." },
        { title: "Планировки и отделка", text: "В квартирах удобные планировки и светлые комнаты. Чистовую отделку выполняем аккуратно." },
      ],
    },
    reviews: {
      eyebrow: "Отзывы",
      title: "Что говорят наши покупатели",
      rating: "Оценка {value} из 5",
    },
    location: {
      eyebrow: "Расположение",
      title: "В центре Беочина",
      lead: "Оба дома находятся на центральной площади Беочина, рядом со всем, что нужно каждый день. До Нови-Сада и национального парка Фрушка-Гора недалеко ехать.",
      lamelaA: "Beočinski trg 4, Беочин",
      lamelaB: "Beočinski trg 2, Беочин",
      office: "Офис продаж",
      mapTitle: "Карта: Beočinski trg, Беочин",
    },
    faq: {
      eyebrow: "Частые вопросы",
      title: "Вопросы о покупке квартиры",
      items: [
        { q: "Где находятся квартиры?", a: "Ламела A находится по адресу Beočinski trg 4, Ламела B по адресу Beočinski trg 2, в центре Беочина рядом с Нови-Садом. Офис продаж: Železnička 11a, Беочин." },
        { q: "Сколько стоят квартиры?", a: "Цены начинаются от {price} и зависят от квартиры, этажа и планировки. Отправьте запрос, чтобы узнать цену и условия покупки выбранной квартиры." },
        { q: "Покупаю ли я напрямую у застройщика?", a: "Да. Мы застройщик, Tehnočin DOO. Вы покупаете квартиру у нас, без посредников." },
        { q: "Какие планировки есть в продаже?", a: "В продаже квартиры от однокомнатных до пятикомнатных, а также коммерческие помещения на первом этаже. В каталоге можно отфильтровать квартиры по планировке, этажу и площади." },
        { q: "Можно ли посмотреть квартиру до покупки?", a: "Да. Позвоните нам по номеру {phone}, чтобы договориться о просмотре дома и квартиры в удобное для вас время." },
        { q: "Как можно оплатить квартиру?", a: "Условия оплаты согласуем с каждым покупателем. Позвоните или отправьте запрос, чтобы обсудить варианты оплаты." },
      ],
    },
    contact: {
      eyebrow: "Контакты",
      title: "Запишитесь на просмотр или запросите предложение",
      lead: "Отправьте запрос, чтобы получить планировки свободных квартир, цены и условия покупки. Можно также позвонить нам.",
      formTitle: "Отправить запрос",
    },
    modalTitle: "Запрос о квартире",
  },
  catalogue: {
    title: "Квартиры в продаже",
    titleProject: "{identifier} · {name}",
    breadcrumb: "Навигационная цепочка",
    all: "Все дома",
    tabs: "Выбор дома",
    address: "Beočinski trg 2 и 4, Беочин",
    filters: "Фильтры",
    reset: "Сбросить",
    resetFilters: "Сбросить фильтры",
    type: "Тип помещения",
    any: "Все",
    structure: "Планировка",
    floor: "Этаж",
    allFloors: "Все этажи",
    area: "Площадь",
    allAreas: "Любая площадь",
    showSold: "Показать и проданные квартиры",
    show: { one: "Показать {count} результат", few: "Показать {count} результата", many: "Показать {count} результатов" },
    notFound: "Не нашли подходящую квартиру?",
    callUs: "Позвоните {phone}",
    results: { one: "{count} объект", few: "{count} объекта", many: "{count} объектов" },
    sort: "Сортировка",
    sorts: { sprat: "По этажу", "povrsina-rastuce": "Площадь: по возрастанию", "povrsina-opadajuce": "Площадь: по убыванию" },
    areas: { "do-40": "до 40 м²", "40-60": "от 40 до 60 м²", "60-80": "от 60 до 80 м²", "80+": "от 80 м²" },
    emptyTitle: "По выбранным фильтрам ничего нет",
    emptyText: "Измените фильтры или позвоните нам. Предложение регулярно обновляется.",
    priceNote: "{identifier}: цены от {from}{to}. Точную цену квартиры и условия оплаты сообщим по запросу.",
    priceTo: " до {price}",
    modalUnit: "Запрос о квартире",
    modalGeneral: "Отправить запрос",
  },
  landing: {
    eyebrow: "Новостройка · Беочинский трг",
    title: "Новые квартиры в центре Беочина",
    roomRange: "Квартиры от {from} до {to}",
    roomRangeFallback: "Квартиры разных планировок",
    priceFrom: "Цены от {price}",
    priceFallback: "Цены по запросу, напрямую от застройщика",
    checkFree: "Посмотрите свободные квартиры",
    stillFree: "Осталось: {label}",
    direct: "Покупка напрямую у застройщика",
    callNow: "Позвоните: {phone}",
    messengerText: "Здравствуйте, меня интересует квартира на Beočinski trg.",
    formTitle: "Отправить запрос",
    formText: "Оставьте номер телефона, и мы пришлём планировки и цены свободных квартир.",
    submit: "Получить предложение",
    messagePlaceholder: "Например, ищу двухкомнатную квартиру на невысоком этаже",
    reviewBy: "{author}, покупатель",
    unitsEyebrow: "Свободные квартиры",
    unitsTitle: "Что есть в продаже сейчас",
    prev: "Предыдущие квартиры",
    next: "Следующие квартиры",
    railLabel: "Список свободных квартир",
    noUnits: "Позвоните нам, чтобы узнать, какие квартиры сейчас в продаже.",
    fullCatalogue: "Смотреть все квартиры",
    locationTitle: "Беочинский трг, Беочин",
    locationText: "Ламела A (Beočinski trg 4) и Ламела B (Beočinski trg 2) находятся в центре Беочина, рядом с Нови-Садом и Фрушка-Горой.",
    office: "Офис продаж: {office}",
    schedule: "Записаться на просмотр",
  },
  thanks: {
    title: "Спасибо, ваш запрос получен!",
    text: "Скоро мы свяжемся с вами и пришлём планировки свободных квартир и цены. Если вопрос срочный, позвоните нам.",
    see: "Все квартиры",
  },
  notFound: {
    title: "Страница не найдена",
    text: "Ссылка могла устареть или содержать ошибку. Посмотрите наши квартиры или вернитесь на главную.",
    home: "Главная страница",
  },
  form: {
    unitFor: "Запрос о:",
    interest: "Что вас интересует?",
    interestOptions: { Jednosoban: "1-комнатная", Dvosoban: "2-комнатная", "Trosoban i veći": "3 комнаты и больше", Lokal: "Коммерческое помещение" },
    name: "Имя и фамилия",
    phone: "Телефон",
    phonePlaceholder: "+381 6x xxx xxxx",
    email: "E-mail",
    message: "Сообщение",
    messagePlaceholder: "Какая квартира вас интересует, когда планируете покупку…",
    honeypot: "Ваш сайт",
    errors: {
      name: "Укажите имя и фамилию.",
      phone: "Укажите корректный номер телефона.",
      email: "Некорректный адрес e-mail.",
      message: "Напишите короткое сообщение.",
    },
    sending: "Отправка…",
    submit: "Отправить запрос",
    sentTitle: "Спасибо, запрос отправлен!",
    sentText: "Мы свяжемся с вами как можно скорее.",
    failed: "Не удалось отправить. Попробуйте ещё раз или позвоните нам по номеру",
    privacy: "Мы используем ваши данные только для ответа на запрос.",
  },
  unit: {
    status: { slobodan: "Свободна", rezervisan: "Забронирована", prodat: "Продана" },
    types: { stan: "Квартира", lokal: "Коммерческое помещение", garaža: "Парковочное место" },
    struktura: {
      "0.5": "Студия",
      "1": "1-комнатная",
      "1.5": "1,5-комнатная",
      "2": "2-комнатная",
      "2.5": "2,5-комнатная",
      "3": "3-комнатная",
      "3.5": "3,5-комнатная",
      "4": "4-комнатная",
      "5": "5-комнатная",
    },
    rooms: "{count} комнаты",
    strukturaPlural: {
      "0.5": "студий",
      "1": "однокомнатных",
      "1.5": "полуторакомнатных",
      "2": "двухкомнатных",
      "2.5": "2,5-комнатных",
      "3": "трёхкомнатных",
      "3.5": "3,5-комнатных",
      "4": "четырёхкомнатных",
      "5": "пятикомнатных",
    },
    floors: { "-1": "Цокольный этаж", "0": "Первый этаж", n: "{n} этаж", attic: "Мансарда", atticOf: "Мансарда ({floor})" },
    floorNumeric: "{n} этаж",
    priceOnRequest: "Цена по запросу",
    viewPlan: "Смотреть планировку: {title}",
    planSoon: "{title}: планировка скоро",
    planAlt: "Планировка: {title}",
    planPlaceholder: "Планировка скоро",
    sold: "Продано",
    inquire: "Запрос",
  },
  project: {
    freeFlats: { one: "{count} свободная квартира", few: "{count} свободные квартиры", many: "{count} свободных квартир" },
    freeShops: { one: "{count} свободное помещение", few: "{count} свободных помещения", many: "{count} свободных помещений" },
    soldPct: "продано {pct}%",
    soldAria: "Продано {pct}% квартир",
    price: "Цена",
    shops: "Коммерция",
    soldOut: "Продано",
    floors: "Этажность",
    floorsValue: "{count} этажей",
    photosSoon: "Фото скоро",
    seeUnits: "Смотреть квартиры",
  },
  footer: {
    tagline: "Семейная строительная компания из Беочина. Квартиру вы покупаете напрямую у нас.",
    site: "Сайт",
    contact: "Контакты",
    follow: "Мы в соцсетях",
    office: "Офис: {office}",
    rights: "Все права защищены.",
  },
  gallery: {
    label: "Галерея",
    close: "Закрыть галерею",
    prev: "Предыдущее фото",
    next: "Следующее фото",
    photo: "Фото",
    of: "{n} из {total}",
    enlarge: "Увеличить фото: {alt}",
  },
  seo: {
    siteName: "Tehnočin DOO",
    home: {
      title: "Новостройки в Беочине у Нови-Сада, Сербия | Tehnočin",
      description: "Новые квартиры на площади Беочинский трг рядом с Нови-Садом, Сербия. Ламела A и B: планировки и цены от 1 200 €/м² напрямую от застройщика Tehnočin.",
    },
    catalogue: {
      title: "Квартиры в Беочине, Сербия: каталог | Tehnočin",
      description: "Все свободные квартиры и коммерческие помещения на Беочинском трге у Нови-Сада. Фильтры по планировке, этажу и площади, планировки и запрос онлайн.",
    },
    catalogueProject: {
      title: "{identifier}: квартиры в продаже, Беочин | Tehnočin",
      description: "{identifier}, {address}: свободные квартиры, планировки и цены. Новостройка в центре Беочина у Нови-Сада напрямую от застройщика Tehnočin DOO.",
    },
    landing: {
      title: "Новые квартиры в центре Беочина | Tehnočin",
      description: "Квартиры от одной до пяти комнат на Беочинском трге у Нови-Сада. Оставьте номер, и мы пришлём планировки и цены свободных квартир.",
    },
    thanks: { title: "Спасибо за запрос | Tehnočin DOO", description: "Ваш запрос получен." },
    notFound: { title: "Страница не найдена | Tehnočin DOO", description: "Запрошенная страница не существует. Посмотрите новые квартиры на Беочинском трге или вернитесь на главную." },
    breadcrumbHome: "Главная",
    breadcrumbUnits: "Квартиры",
  },
};

export default ru;
